exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-tel-input[data-v-2050bd50]:focus-within, .vue-tel-input[data-v-2050bd50]:focus {\n\tborder-color: #f18b8f !important;\n\tbox-shadow: none !important;\n}\n", ""]);

// exports
